import appConfig from '../../../config/app';
import { Observable } from 'rxjs';

const apiRoot = appConfig.newApiUrl;

const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json; charset=UTF-8'
};

export default {

    get(url) {
        return this.sendRequest("GET", url)
    },
    post(url, body) {
        return this.sendRequest('POST', url, body)
    },
    patch(url, body) {
        return this.sendRequest("PATCH", url, body)
    },
    sendRequest(httpMethod, url, body) {

        //TODO: получать аутентификационные заголовки параметром.
        let authToken = localStorage.getItem('AuthToken') || null;
        if (authToken) {
            headers['Authorization'] = `Bearer ${authToken}`;
        }

        const config = {
            method: httpMethod,
            headers
        };

        if (body) {
            config.body = JSON.stringify(body);
        }

        return new Observable((observer) => {
            fetch(apiRoot + url, config)
                .then(response => {

                    if (response.status === 204) {
                        observer.next();
                        observer.complete();
                        return;
                    }

                    response.json().then(json => {
                        if (!response.ok) {
                            observer.error({code: response.status, error: json.error});
                            return;
                        }

                        observer.next(json);
                        observer.complete();
                    })
                })
                .catch(error => {
                    observer.error(error);
                });
        });
    }
}


// WEBPACK FOOTER //
// ./apiClient/HttpClient/NewApi/index.js